import { Container } from "@mantine/core"
import { UseQueryResult } from "@tanstack/react-query"
import { ErrorBox, InfoBox, Loader } from "@tfg/ui"
import { AxiosError } from "axios"
import _ from "lodash"
import { useTranslation } from "react-i18next"

export type DataWrapperChildrenType<TData> = (props: {
  data: TData
  isFetching: boolean
  isLoading: boolean
  refetch: () => void
}) => JSX.Element

type Props<TData, TError> = {
  query: UseQueryResult<TData, TError>
  children: DataWrapperChildrenType<TData>
  acceptEmpty?: boolean
  showLoader?: boolean
}

export const DataFetchWrapper = <TData, TError>({
  query,
  children,
  acceptEmpty,
  showLoader = true,
}: Props<TData, TError>) => {
  const { t } = useTranslation()
  const { data, isPending: isLoading, isError, error } = query

  if (isError) {
    return (
      <Container w="100%" h="100%">
        <ErrorBox
          title={t("dataLoad.error.title")}
          error={error as AxiosError}
        />
      </Container>
    )
  }
  if (isLoading) return showLoader ? <Loader fullPage /> : null
  if (!acceptEmpty && (!data || _.isEmpty(data))) {
    return (
      <Container w="100%" h="100%">
        <InfoBox
          title={t("dataLoad.noResults.title")}
          message={t("dataLoad.noResults.message")}
        />
      </Container>
    )
  }
  return children(query)
}
